import { useDispatch, useSelector } from "react-redux";
import { addNowPlayingMovies } from "../store/slices/moviesSlice";
import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";
import { RootState } from "../store";

const useNowPlayingMovies = () => {
  const dispatch = useDispatch();
  const nowPlayingMovies = useSelector((store: RootState) => store.movies.nowPlayingMovies);

  const getNowPlayingMovies = useCallback(async () => {
    try {
      const data = await fetch(
        "https://api.themoviedb.org/3/movie/now_playing?page=1",
        API_OPTIONS
      );
      const json = await data.json();
      dispatch(addNowPlayingMovies(json.results));
    } catch (error) {
      console.error("Error fetching now playing movies:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!nowPlayingMovies) getNowPlayingMovies();
  }, [nowPlayingMovies, getNowPlayingMovies]);
};

export default useNowPlayingMovies;
